import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { moduleKeyForPath } from "../Components/HomePage/modulePaths";
import { DashboardModuleKey } from "../Models/dashboard";
import { useMarkModuleOpened } from "../Query/useDashboard";

/**
 * Records a visit when the user enters a dashboard module, for the home
 * dashboard's "Recently used" filter. Moving between pages of the same module
 * is one visit, so browsing an entity's tabs does not send a request per page.
 */
export const useModuleVisitTracker = () => {
  const { pathname } = useLocation();
  const { mutate } = useMarkModuleOpened();
  const lastModule = useRef<DashboardModuleKey | null>(null);
  const moduleKey = moduleKeyForPath(pathname);

  useEffect(() => {
    if (moduleKey === lastModule.current) return;
    lastModule.current = moduleKey;
    if (moduleKey) mutate(moduleKey);
  }, [moduleKey, mutate]);
};
